export default __webpack_public_path__ + "static/media/IBMPlexSans-TextItalic-Latin1.2903f4b1.woff2";